<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">
      {{ $t('Ataskaitos formavimas') }}
    </h1>
    <!-- type card -->
    <report-type-form @setTypeData="setTypeData" :formData="formData" />
    <!-- criteria card -->
    <report-criteria-form :formData="formData" @clear-criteria="clearCriteria" />
  </v-container>
</template>

<script>
import Enums from '@/enums'
import ReportTypeForm from './components/ReportTypeForm.vue'
import ReportCriteriaForm from './components/ReportCriteriaForm.vue'

export default {
  name: 'NewReport',
  components: {
    ReportTypeForm,
    ReportCriteriaForm,
  },
  data() {
    return {
      formData: {
        criteria: [],
      },
      loading: false,
      pageloading: false,
      enumsClassifiers: [],
    }
  },
  computed: {},
  created() {
    this.enumsClassifiers = Enums
  },
  methods: {
    setTypeData(data) {
      this.$set(this.formData, 'criteria', [])
      this.$set(this.formData, 'type', data)
    },
    clearCriteria() {
      this.$set(this.formData, 'criteria', {})
    },
  },
}
</script>
<style lang="scss" scoped></style>